import { Component, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Menu } from '../../models/menu';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { TranslateService } from '@ngx-translate/core';
import { ApiResponseTable } from '../../models/api-response-table';
import { LoggerService } from 'src/app/services/logger.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: '<app-menu>',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent {
  constructor(
    private http: HttpClient,
    private apiService: UserApiService,
    private router: Router,
    public logger: LoggerService,
    private database: DataService,
    public translateService: TranslateService
  ) {
    this.menuListData = [];
    this.menuList = [];
    this.userPrivileges = [];
    this.getData();
    // this.http.get<[]>
    //   ("./assets/menu.json")
    //   .subscribe((settings) => {
    //     this.menuListData = settings;
    //     for (let index = 0; index < this.menuListData.length; index++) {
    //       const element = this.menuListData[index];
    //       this.menuList.push(element);
    //     }
    //   });

    this.searchedItem = '';
  }

  public getData() {
    try {
      var isAdminStorage: any = localStorage.getItem('isAdmin');
      if (isAdminStorage == null) {
        this.router.navigate(['']);
        return;
      }

      if (isAdminStorage != 'true' && isAdminStorage != 'false') {
        this.router.navigate(['']);
      }
      let url = `Menu?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;

      if (localStorage.getItem('isAdmin') == 'false') {
        var roleIdsString = localStorage.getItem('roleIds');

        if (roleIdsString == null || roleIdsString == '') {
          this.router.navigate(['']);
          return;
        }
        var roleIds = roleIdsString?.split(',');

        url = `Menu?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc&search=roleName~${roleIds[0]}`;
      }

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded && result.data != null) {
            var foundedItemPermission = result.data.items.filter(
              (current) => !current.visible
            );
            this.savePermission(foundedItemPermission);
            var foundedMenuPermission = result.data.items.filter(
              (current) => current.visible
            );
            this.mapData(foundedMenuPermission);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {}
  }

  public mapData(result: any[]) {
    try {
      if (result == null) {
        this.logger.addError('Loading_Menu_Error', false);
        return;
      }

      var foundedMenuItems = result
        .filter((current) => current.parentId == null)
        .sort((a, b) => (a.order < b.order ? -1 : 1));

      for (let index = 0; index < foundedMenuItems.length; index++) {
        const element = foundedMenuItems[index];
        const menuElement = new Menu(element);

        var foundedChilds = result
          .filter((current) => current.parentId == element.id)
          .sort((a, b) => (a.order < b.order ? -1 : 1));

        for (
          let secondindex = 0;
          secondindex < foundedChilds.length;
          secondindex++
        ) {
          const secondElement = foundedChilds[secondindex];
          const subMenuElement = new Menu(secondElement);

          var foundedSecondChilds = result
            .filter((current) => current.parentId == secondElement.id)
            .sort((a, b) => (a.order < b.order ? -1 : 1));

          for (
            let thirdindex = 0;
            thirdindex < foundedSecondChilds.length;
            thirdindex++
          ) {
            const thirdelement = foundedSecondChilds[thirdindex];
            const secondSubMenuElement = new Menu(thirdelement);
            subMenuElement.children.push(secondSubMenuElement);
          }

          menuElement.children.push(subMenuElement);
        }
        this.menuListData.push(menuElement);
      }

      for (let index = 0; index < this.menuListData.length; index++) {
        const element = this.menuListData[index];
        this.menuList.push(element);
      }
    } catch (error) {
      this.logger.addException(error, true);
    }
  }

  private savePermission(result: any[]) {
    try {
      this.database.setData(result, 'ButtonPermission');
    } catch (error) {
      this.logger.addError('Load_Permission_Error', false);
    }
  }

  @ViewChild('closeButton') closeButton?: ElementRef;

  public menuListData: Menu[];

  public menuList: Menu[];

  public searchedItem: string;

  public userPrivileges: any[];

  public loadScript(url: any) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  public ngOnInit(): void {
    this.loadScript('../assets/js/main.js');
  }

  public closeMenu(): void {
    if (window.innerWidth >= 1200) {
      return;
    }
    if (this.closeButton == null) {
      return;
    }

    let el: HTMLElement = this.closeButton.nativeElement as HTMLElement;

    el.click();
  }

  public searchMenu(): void {
    if (this.translateService.currentLang == 'fa') {
      if (this.searchedItem == null || this.searchedItem == '') {
        this.menuList = [];
        // this.menuList = this.menuListData;
        for (let index = 0; index < this.menuListData.length; index++) {
          const element = this.menuListData[index];
          this.menuList.push(element);
        }
        return;
      }
      var foundedItems = this.menuListData.filter(
        (current) =>
          this.translateService
            .instant(current.name)
            .indexOf(this.searchedItem) >= 0 &&
          (current.children == null || current.children.length == 0)
      );

      this.menuList = this.pushAll(foundedItems, this.menuList);

      this.menuList = [];
      for (let index = 0; index < this.menuListData.length; index++) {
        const element = this.menuListData[index];
        if (element.children == null) {
          continue;
        }

        foundedItems = element.children.filter(
          (current) =>
            this.translateService
              .instant(current.name)
              .indexOf(this.searchedItem) >= 0 &&
            (current.children == null || current.children.length == 0)
        );
        this.menuList = this.pushAll(foundedItems, this.menuList);

        for (
          let secondIndex = 0;
          secondIndex < element.children.length;
          secondIndex++
        ) {
          const secondElement = element.children[secondIndex];
          if (secondElement.children == null) {
            continue;
          }
          foundedItems = secondElement.children.filter(
            (current) =>
              this.translateService
                .instant(current.name)
                .indexOf(this.searchedItem) >= 0 &&
              (current.children == null || current.children.length == 0)
          );

          this.menuList = this.pushAll(foundedItems, this.menuList);
        }
      }
    } else {
      if (this.searchedItem == null || this.searchedItem == '') {
        this.menuList = [];
        // this.menuList = this.menuListData;
        for (let index = 0; index < this.menuListData.length; index++) {
          const element = this.menuListData[index];
          this.menuList.push(element);
        }
        return;
      }
      var foundedItems = this.menuListData.filter(
        (current) =>
          this.translateService
            .instant(current.name)
            .toUpperCase()
            .indexOf(this.searchedItem.toUpperCase()) >= 0 &&
          (current.children == null || current.children.length == 0)
      );

      this.menuList = this.pushAll(foundedItems, this.menuList);

      this.menuList = [];
      for (let index = 0; index < this.menuListData.length; index++) {
        const element = this.menuListData[index];
        if (element.children == null) {
          continue;
        }

        foundedItems = element.children.filter(
          (current) =>
            this.translateService
              .instant(current.name)
              .toUpperCase()
              .indexOf(this.searchedItem.toUpperCase()) >= 0 &&
            (current.children == null || current.children.length == 0)
        );
        this.menuList = this.pushAll(foundedItems, this.menuList);

        for (
          let secondIndex = 0;
          secondIndex < element.children.length;
          secondIndex++
        ) {
          const secondElement = element.children[secondIndex];
          if (secondElement.children == null) {
            continue;
          }
          foundedItems = secondElement.children.filter(
            (current) =>
              this.translateService
                .instant(current.name)
                .toUpperCase()
                .indexOf(this.searchedItem.toUpperCase()) >= 0 &&
              (current.children == null || current.children.length == 0)
          );

          this.menuList = this.pushAll(foundedItems, this.menuList);
        }
      }
    }
  }

  public pushAll(sourceArray: any[], destinationArray: any[]): any[] {
    if (sourceArray == null || destinationArray == null) {
      return [];
    }

    for (let index = 0; index < sourceArray.length; index++) {
      const element = sourceArray[index];
      var elementJson = {};

      elementJson['name'] = element.name;
      elementJson['icon'] = element.icon;
      elementJson['url'] = element.url;
      elementJson['color'] = element.color;
      elementJson['children'] = [];

      destinationArray.push(elementJson);
      console.log(this.menuListData);
    }
    return destinationArray;
  }
  // ----------------------ToDO---------------------
  public getPermissionData(settings: any[]) {
    try {
      this.apiService
        .getSingleItem(new ApiRequestModel(`User/GetMe`))
        .subscribe(
          (result) => {
            const url = `/Rolestore?orderBy=&direction=&page=0&size=1000&paginate=false&search=id:${result.roleIds[0]}`;
            if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
              return;
            }
            this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
              (result) => {
                if (result.succeeded) {
                  if (result && result[0].length > 0) {
                    this.userPrivileges = result[0];
                    this.setPermissionData(settings);
                  }
                } else {
                  this.logger.addBackEndMessage(result);
                }
              },
              (error) => {
                this.apiService.AddErrorLog(error);
              },
              () => {}
            );
          },
          (error) => {
            this.apiService.AddErrorLog(error);
          },
          () => {}
        );
    } catch (error) {
      this.logger.addException(error, true);
    }
  }

  private setPermissionData(settings: any[]) {
    try {
      for (let index = 0; index < settings.length; index++) {
        const element = settings[index];

        if (element.children) {
        }
      }
    } catch (error) {
      this.logger.addException(error, true);
    }
  }
  // ----------------------ToDO---------------------
}
